import { getLocale } from "../runtime";

const da_buymoresave = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Køb mere & spar!`
};

const en_buymoresave = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Buy more & save!`
};

const es_buymoresave = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `¡Compra más y ahorra!`
};

const fi_buymoresave = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Osta enemmän & säästä!`
};

const nb_buymoresave = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Kjøp mer & spar!`
};

const sv_buymoresave = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Köp fler & spara!`
};

const buymoresave = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "da") return da_buymoresave(inputs)
	if (locale === "en") return en_buymoresave(inputs)
	if (locale === "es") return es_buymoresave(inputs)
	if (locale === "fi") return fi_buymoresave(inputs)
	if (locale === "nb") return nb_buymoresave(inputs)
	if (locale === "sv") return sv_buymoresave(inputs)
	return "buyMoreSave";
};

export { buymoresave as "buyMoreSave" };